// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorAccessDenied_wrapper_20KWK","icon":"ErrorAccessDenied_icon_2DhGX","title":"ErrorAccessDenied_title_1RWV8"};